<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Device Usage</h1>
          </div>
        </div>
      </div>
      <!-- /.container-fluid -->
    </section>

    <template>
      <vue-highcharts
        :options="deviceUsageHighChartOptions"
        ref="lineCharts"
      ></vue-highcharts>
    </template>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from '@/components/partials/PaginationComponent'
import axios from 'axios'
import 'vue2-datepicker/index.css'
import { CommonAPI, PermissionChecker } from '@/services/api'
import { mapGetters, mapActions } from 'vuex'
import { Notification } from 'element-ui'
import VueHighcharts from "vue2-highcharts";


export default {
  name: 'DeviceUsage',
  metaInfo: {
    title: 'Device Usage | Dotlines'
  },
  components: {
    VueHighcharts
  },

  data: () => ({
    list: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1
    },
    actionCreate: false,
    actionView: false,
    actionEdit: false,
    actionDelete: false,
    api_url: '',
    showFilter: false,
    filter: {},
    dateRange: '',
    pre: {},
    actionStatus: '',
    is_loading: false,
    empty: false,
    empty_message: '',
    custom_permission_data: [],
    has_permission: true,
    deviceUsage: '',

    deviceUsageHighChartOptions: {
      chart: {
        type: "spline",
      },
      title: {
        text: "Bandwidth Graph (Last 1 hour)",
        style: {
          fontFamily: "Inter",
          fontSize: "16px",
          fontWeight: "500",
          color: "#1e2d2c",
        },
      },
      subtitle: {
        text: null,
      },
      xAxis: {
        categories: [],
        title: {
          // text: "Time",
        },
      },
      yAxis: {
        title: {
          text: "Kbps",
          style: {
            fontFamily: "Inter",
            fontSize: "12px",
            fontWeight: "500",
            color: "#1e2d2c",
          },
        },
        // labels: {
        //   formatter: function () {
        //     return this.value + '°';
        //   }
        // }
      },
      tooltip: {
        crosshairs: true,
        shared: true,
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        spline: {
          marker: {
            radius: 4,
            lineColor: "#666666",
            lineWidth: 1,
          },
        },
      },
      series: [],
    },
  }),
  mounted: function () {
    if (this.isMobile()) {
      window
        .$(document)
        .find('.push-menu-class')
        .trigger('click')
    }
    this.api_url =
      '/deviceUsage/' +
      this.$route.params.accountId +
      '/' +
      this.$route.params.device_mac
    // this.filter = this.$route.params;

    this.initialize()
    this.$root.$on('sort-data', () => {
      this.$root.$emit('show-icon')
      this.reload()
    })
  },
  computed: {
    ...mapGetters(['profile'])
  },
  methods: {
    async initialize () {
      this.is_loading = true
      if (_.isEmpty(this.profile)) {
        await CommonAPI.getProfile().then(profile_info => {
          this.user_detail = profile_info
        })
      } else {
        this.user_detail = this.profile
      }

      await CommonAPI.getCustomPermission(
        '/get-custom-permission-infos?path=api/devices'
      ).then(response => {
        if (response.status == 200) {
          this.custom_permission_data = response.data
        }
      })

      if (!_.isEmpty(this.custom_permission_data)) {
        this.actionCreate = await PermissionChecker.checkCreateButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data['create_id_condition'],
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        )
      }

      await this.getDeviceUsage()
        .then(response => {
          this.deviceUsage = response.data
          this.setDeviceUsageChartData()
        })
        .catch(error => {
          this.empty = true
          // if (error.response.status === 403) {
          //   this.has_permission = false;
          // }
          console.log(error)
        })

      this.is_loading = false
    },
    checkEditPermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkEditButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data['edit_id_condition'],
          this.custom_permission_data['edit_refid_condition'],
          this.custom_permission_data['edit_custom_condition'],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        )
      } else {
        return false
      }
    },
    checkDeletePermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkDeleteButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data['delete_id_condition'],
          this.custom_permission_data['delete_refid_condition'],
          this.custom_permission_data['delete_custom_condition'],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        )
      } else {
        return false
      }
    },

    getDeviceUsage () {
      return new Promise((resolve, reject) => {
        axios
          .get(this.api_url)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
            //console.log("error", error.response.data);
          })
          .finally(() => {
            //_this.is_loading = false;
          })
      })
    },

    setDeviceUsageChartData () {
      let Gbflag = 0
      let Mbflag = 0
      const arrayLength = this.deviceUsage.length
      let download = 0
      let upload = 0

      const categories = []
      const downloadData = {
        name: 'Download',

        marker: {
          symbol: 'circle',
        },
        data: [],
      };

      const uploadData = {
        name: 'Upload',
        marker: {
          symbol: 'circle',
        },
        data: [],
      };

      for (let i = 0; i < arrayLength; i++) {
        const item = this.deviceUsage[i]
        download =
          item.timeinterval > 0
            ? (item.download / item.timeinterval).toFixed(2)
            : 0
        upload =
          item.timeinterval > 0
            ? (item.upload / item.timeinterval).toFixed(2)
            : 0
        if (isNaN(download) || !download) download = 0
        if (isNaN(upload) || !upload) upload = 0
        if (download > 1000) {
          if (parseInt(download / 1000) > 1000) Gbflag = 1
          else Mbflag = 1
        }

        if (upload > 1000) {
          if (parseInt(upload / 1000) > 1000) Gbflag = 1
          else Mbflag = 1
        }
      }

      for (let i = 0; i < arrayLength; i++) {
        const item = this.deviceUsage[i]
        download =
          item.timeinterval > 0
            ? (item.download / item.timeinterval).toFixed(2)
            : 0
        upload =
          item.timeinterval > 0
            ? (item.upload / item.timeinterval).toFixed(2)
            : 0
        if (Gbflag == 1) {
          download = (download / 1000 / 1000).toFixed(2)
          upload = (upload / 1000 / 1000).toFixed(2)
        } else if (Mbflag == 1) {
          download = (download / 1000).toFixed(2)
          upload = (upload / 1000).toFixed(2)
        }

        if (isNaN(download) || !download) download = 0
        if (isNaN(upload) || !upload) upload = 0

        categories.push(item.StartTime.slice(0, -3));
        downloadData.data.push(parseInt(download));
        uploadData.data.push(parseInt(upload));
      }
      // if(Gbflag == 1)
      // 	deviceUsageChart.options.scales.yAxes[0].scaleLabel.labelString = "Gbps";
      // else if(Mbflag == 1)
      // 	deviceUsageChart.options.scales.yAxes[0].scaleLabel.labelString = "Mbps";
      // else
      // 	deviceUsageChart.options.scales.yAxes[0].scaleLabel.labelString = "Kbps";
      // deviceUsageChart.update();

      const lineCharts = this.$refs.lineCharts;

      lineCharts.delegateMethod('showLoading', 'Loading...');
      lineCharts.addSeries(downloadData);
      lineCharts.addSeries(uploadData);

      lineCharts.getChart().xAxis[0].setCategories(categories);

      if (Gbflag == 1) {
        lineCharts.getChart().yAxis[0].setTitle({text: 'Gbps'});
      } else if (Mbflag == 1) {
        lineCharts.getChart().yAxis[0].setTitle({text: 'Mbps'});
      } else {
        lineCharts.getChart().yAxis[0].setTitle({text: 'Kbps'});
      }

      lineCharts.hideLoading();
    }
  }
  /*created() {
      this.$emit("update:layout", MasterLayout);
    },*/
}
</script>
